import PropTypes from 'prop-types';
import React from 'react'


export default class extends React.Component {
    static propTypes = {
		editable: PropTypes.bool.isRequired,
		ID: PropTypes.number.isRequired,
		title: PropTypes.string.isRequired,
		clickAction: PropTypes.func,
		selected: PropTypes.bool,
	};

    clickAction = () => {
		if( this.props.clickAction ) this.props.clickAction( this.props.ID );
	};

    render() {

		return (
			<div className={"interestBox toggle " + (this.props.selected ? 'selected' : '')} onClick={this.props.editable ? this.clickAction : false}>
				<p>{this.props.tag}</p>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Interests/components/Single.js